// src/components/PriceModal.tsx
import React from 'react'
import './SellModal.css'

interface SellModalProps {
  isOpen: boolean
  value: string
  onChange: (v: string) => void
  onCancel: () => void
  onSubmit: (v: string) => void
}

const SellModal: React.FC<SellModalProps> = ({
  isOpen,
  value,
  onChange,
  onCancel,
  onSubmit
}) => {
  if (!isOpen) return null

  return (
    <div className="pm-overlay">
      <div className="pm-container">
        <div className="pm-header">
          <h2 className="pm-title">Building Price</h2>
        </div>

        <div className="pm-body">
          <p className="pm-desc">
            Please enter the Bid price
          </p>
          <input
            type="number"
            className="pm-input"
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder="e.g. 250000"
          />
        </div>

        <div className="pm-footer">
          <button className="pm-btn pm-btn--cancel" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="pm-btn pm-btn--submit"
            onClick={() => onSubmit(value)}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  )
}

export default SellModal
